module.exports = __webpack_public_path__ + "static/media/name.9e4e3498.png";